angular.module('st').requires.push('ngSanitize');

angular.module('st').config(['$locationProvider', function($locationProvider){
    // hack for html5Mode customization, this hack makes it so locationprovider can work without breaking non angulars route links by adding the "target" attribute to normal html a tags
    $('a').each(function(){
        $a = $(this);
        if ($a.is('[target]') || $a.is('[ng-href]')){
        } else {
            $a.attr('target', '_self');
        }
    });

$locationProvider.html5Mode({
  enabled: true,
  requireBase: false
  })
}])

//console.info("load", locationsListCtrl);
angular.module('st').controller('locationsListCtrl', locationsListCtrl);

locationsListCtrl.$inject = ['$scope', '$rootScope', '$sce', '$filter', '$location'];

function locationsListCtrl($scope, $rootScope, $sce, $filter, $location) {
    var vm = this;
    var queryLocation = $location.search().location;
    console.info("locations list ctrl");

    $scope.regionSelector = queryLocation || "default";

    vm.changeRegion = function(newLocation) {
        console.log('new region', newLocation);
        $location.search('location', newLocation);
    };

    vm.init = function () {
        console.info("init");
    }

}


